export default __webpack_public_path__ + "static/media/yuryu-13.4c99e17f.svg";